<app-layout>
          



<!-- components title start -->
<div class="components-title">
    <h2>{{ $t('My Dashboard') }}</h2>
</div>
<!-- components title end -->


            <div class="table-home__linkk">
                <inertia-link :href="route('wallets')" class="active"><h4>{{ $t('My Wallets') }}</h4></inertia-link>
		<inertia-link :href="route('orders')"><h4>{{ $t('My Orders') }}</h4></inertia-link>
		<inertia-link :href="route('reports.trades')"><h4>{{ $t('My Transactions') }}</h4></inertia-link>
            </div>

<!-- components title start -->
<div class="portfolio-title">
    <h3>{{ $t('Current PORTFOLIO value') }}</h3>
    <h3> ${{ totalValueInUSDT.toLocaleString() }}</h3>
</div>
<!-- components title end -->


<!-- components title start -->
<div class="components-title">
    <h3 class="sectit">{{ $t('Wallets') }}</h3>
</div>
<!-- components title end -->


<!-- tabs components start -->
<div class="tabs-components tabs">

    <!-- tabs right start -->
    <div class="tabs-right">
        <div class="tabs-search">
            <input v-model="filter.search" type="text" :placeholder="$t('Search Coin Name')">
            <button class="tabs-search__icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect class="tabs-search__color" x="2" y="2" width="17" height="17" rx="8.5"/>
                    <line class="tabs-search__color" x1="16.2428" y1="17.5356" x2="20.5356" y2="21.8285"/>
                </svg>
            </button>
        </div>
    </div>
    <!-- tabs right end -->

</div>
<!-- tabs components end -->


<!-- table components start -->
<div class="table-components">

    <!-- tables start -->
    <table class="tables mob-table-wallets">

        <!-- thead start -->
        <thead class="table-sort">
            <tr>
                <th>
                    <div @click="setFilter('symbol')" class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Currency') }}</span>
                        <span class="table-sort__icon">
                            <icon-filter
                                :filter="filter"
                                field="symbol">
                            </icon-filter>
                        </span>
                    </div>
                </th>
                <th>
                    <div @click="setFilter('balance_in_wallet')" class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Available') }}</span>
                        <span class="table-sort__icon">
                            <icon-filter
                                :filter="filter"
                                field="balance_in_wallet">
                            </icon-filter>
                        </span>
                    </div>
                </th>
                <th>
                    <div @click="setFilter('balance_in_order')" class="table-sort__value">
                        <span class="table-sort__title">{{ $t('In Orders') }}</span>
                        <span class="table-sort__icon">
                            <icon-filter
                                :filter="filter"
                                field="balance_in_order">
                            </icon-filter>
                        </span>
                    </div>
                </th>
                <th>
                    <div @click="setFilter('balance_in_order')" class="table-sort__value">
                        <span class="table-sort__title">{{ $t('In Futures') }}</span>
                        <span class="table-sort__icon">
                            <icon-filter
                                :filter="filter"
                                field="balance_in_order">
                            </icon-filter>
                        </span>
                    </div>
                </th>
                <th>
                    <div @click="setFilter('balance_in_withdraw')" class="table-sort__value">
                        <span class="table-sort__title">{{ $t('In Withdraw') }}</span>
                        <span class="table-sort__icon">
                            <icon-filter
                                :filter="filter"
                                field="balance_in_withdraw">
                            </icon-filter>
                        </span>
                    </div>
                </th>
                <th>
                    <div @click="setFilter('type')" class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Type') }}</span>
                        <span class="table-sort__icon">
                            <icon-filter
                                :filter="filter"
                                field="tye">
                            </icon-filter>
                        </span>
                    </div>
                </th>

		                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Value') }}</span>
                    </div>
                </th>

                <th>
                    <div class="table-sort__value">
                        <span class="table-sort__title">{{ $t('Actions') }}</span>
                    </div>
                </th>
            </tr>
        </thead>
        <!-- thead end -->

        <!-- tbody start -->
        <tbody class="table-list">
            <tr v-for="wallet in wallets" :key="wallet.id">
                <td>
                    <div class="table-list__subtitle">{{ $t('Currency') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__image"><img :src="wallet.logo"></div>
                        <div class="table-list__title">
                            <span class="table-list__title-big">{{ wallet.symbol }}</span>
                            <span class="table-list__title-small">{{ wallet.currency }}</span>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Available') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__text">{{ wallet.balance_in_wallet }}</div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('In Orders') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__text">{{ wallet.balance_in_order }}</div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('In Futures') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__text">0.0000</div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('In Withdraw') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__text">{{ wallet.balance_in_withdraw }}</div>
                    </div>
                </td>
                <td>
                    <div class="table-list__subtitle">{{ $t('Type') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__text">{{ wallet.type == "coin" ? 'Coin' : 'Fiat' }}</div>
                    </div>
                 </td>

                <td>
                    <div class="table-list__subtitle">{{ $t('Value') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__text">${{ calculateValueInUSDT(wallet) }}</div>
                    </div>
                 </td>

                <td>
                    <div class="table-list__subtitle">{{ $t('Actions') }}</div>
                    <div class="table-list__value">
                        <div class="table-list__link">
                            <inertia-link v-if="wallet.type == 'fiat'" :href="route('wallets.deposit.fiat', { symbol: wallet.symbol })">
                                {{ $t('Deposit') }}
                            </inertia-link>
                            <inertia-link v-else :href="route('wallets.deposit.crypto', { symbol: wallet.symbol })">
                                {{ $t('Deposit') }}
                            </inertia-link>
                            <inertia-link v-if="wallet.type == 'fiat'" :href="route('wallets.withdraw.fiat', { symbol: wallet.symbol })">
                                {{ $t('Withdraw') }}
                            </inertia-link>
                            <inertia-link v-else :href="route('wallets.withdraw.crypto', { symbol: wallet.symbol })">
                                {{ $t('Withdraw') }}
                            </inertia-link>
			    <template v-if="wallet.symbol !== 'USDT'">
			        <inertia-link :href="route('market', { id: wallet.symbol + '-USDT' })">
                                   {{ $t('Trade') }}
                                </inertia-link>
                            </template>


                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
        <!-- tbody end -->

        <!-- tfood start -->
        <tfoot class="table-result">
            <tr>
                <td colspan="100">
                    <div v-if="wallets.length == 0" class="table-result__notfound">
                        <span class="table-result__notfound-icon">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path class="table-result__notfound-color" d="M21 13V11C21 7.73081 21 6.09621 20.3272 4.86413C19.8219 3.93873 19.0613 3.17807 18.1359 2.67277C16.9038 2 15.2692 2 12 2V2C8.73081 2 7.09621 2 5.86413 2.67277C4.93873 3.17807 4.17807 3.93873 3.67277 4.86413C3 6.09621 3 7.73081 3 11V12.5C3 16.2433 3 18.1149 3.87311 19.4735C4.29935 20.1368 4.86322 20.7006 5.52648 21.1269C6.88505 22 8.7567 22 12.5 22V22H13" stroke="#222628"/>
                                <line class="table-result__notfound-color" x1="15.5" y1="13.5" x2="7.5" y2="13.5"/>
                                <line class="table-result__notfound-color" x1="15.5" y1="10.5" x2="7.5" y2="10.5"/>
                                <line class="table-result__notfound-color" x1="11.5" y1="7.5" x2="7.5" y2="7.5"/>
                                <rect class="table-result__notfound-color color-yellow" x="14.8335" y="14.8335" width="7.08333" height="7.08333" rx="3.54167"/>
                                <line class="table-result__notfound-color color-yellow" x1="21.1803" y1="21.3066" x2="22.5565" y2="22.6829"/>
                            </svg>
                        </span>
                        <span class="table-result__notfound-text">{{ $t('No wallets found.') }}</span>
                    </div>
                </td>
            </tr>
        </tfoot>
        <!-- tfood end -->

    </table>
    <!-- tables end -->

</div>
<!-- table components end -->


</app-layout>
